// extracted by mini-css-extract-plugin
module.exports = {"Card":"styles_Card__3tK8f","ResultsCard":"styles_ResultsCard__3q31E","ResultsCardTitle":"styles_ResultsCardTitle__202p0","ResultsCardIcon":"styles_ResultsCardIcon__2uo-5"};